export default __webpack_public_path__ + "static/media/whitepaper.142ff954.pdf";